import wrapWithProvider from "./wrap-with-provider";

require("materialize-css/dist/js/materialize.min.js");

export const wrapRootElement = wrapWithProvider;